import AssetCard from "../../../../components/Assetcard";
import {
  Grid,
  Stack,
  TextField,
  Typography,
  Autocomplete,
  Button,
  IconButton,
  Box,
  Switch,
  FormControlLabel,
  Divider,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Alert,
} from "@mui/material";
import { useApp } from "../../../../hooks/useApp";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import { emitToast } from "../../../../common/toastEmitter";
import AddCircleRoundedIcon from "@mui/icons-material/AddCircleRounded";
import ImageUpload from "../../../../components/ImageUpload";

export default function FactoryTwo({ asset, setAsset }) {
  const { combinedAssets } = useApp();
  function handleChange(event) {
    const newAsset = { ...asset, [event.target.id]: event.target.value };
    setAsset(newAsset);
  }
  const handleAddMore = () => {
    const count = asset.suites.length; // or another method to generate unique index
    const newChild = {
      sortOrder: count + 1,
      factoryId: "",
      title: "",
      color: "",
      textHeader: "",
      text: "",
    };
    const newChildren = [...asset.suites, newChild];
    setAsset((prevAsset) => ({ ...prevAsset, suites: newChildren }));
  };
  const handleRemove = (factoryToRemove) => {
    setAsset((prevAsset) => ({
      ...prevAsset,
      suites: prevAsset.suites.filter((factory) => factory !== factoryToRemove),
    }));
  };
  const handleFactoryChange = (index, newValue) => {
    const factoryId = newValue ? newValue.id : "";

    if (asset.suites.some((child) => child.factoryId === factoryId)) {
      emitToast("Already Selected factory, Please choose another", "error");
      setAsset((prevAsset) => {
        const newSuites = [...prevAsset.suites];
        newSuites[index] = { ...newSuites[index], factoryId: null };
        return { ...prevAsset, suites: newSuites };
      });
      return;
    }

    setAsset((prevAsset) => {
      const newSuites = [...prevAsset.suites];
      newSuites[index] = { ...newSuites[index], factoryId };
      return { ...prevAsset, suites: newSuites };
    });
  };

  const handleColorChange = (index, newColor) => {
    setAsset((prevAsset) => {
      const newSuites = [...prevAsset.suites];
      newSuites[index] = { ...newSuites[index], color: newColor };
      return { ...prevAsset, suites: newSuites };
    });
  };
  const handleTextChange = (event, index) => {
    setAsset((prevAsset) => {
      const newSuites = [...prevAsset.suites];
      newSuites[index] = {
        ...newSuites[index],
        [event.target.name]: event.target.value,
      };
      return { ...prevAsset, suites: newSuites };
    });
  };
  const getFactoryOptions = () =>
    combinedAssets.filter((asset) => asset.Type === "factory");
  const getSelectedFactory = (id) =>
    combinedAssets.find((ex) => ex.id === id || null);
  const handleFileUploadChange = (file) => {
      const newAsset = { ...asset, Image: file };
      setAsset(newAsset);
  };

  return (
    <Grid container sx={{ flexDirection: "row", gap: 4 }}>
      <Grid
        item
        xs={12}
        md={5}
        sx={{ justifyContent: "center", alignItems: "center" }}
      >
        <AssetCard asset={asset} />
      </Grid>
      <Grid item xs>
        <Stack direction={"column"} gap={2}>
          
          <TextField
            id="Title"
            label="Title"
            fullWidth
            value={asset.Title}
            onChange={(event) => {
              handleChange(event);
            }}
          />
          <TextField
            id="Heading"
            label="Heading"
            fullWidth
            value={asset.Heading}
            onChange={(event) => {
              handleChange(event);
            }}
          />
          <TextField
            id="private"
            label="Private Asset ID"
            fullWidth
            value={asset.private}
            onChange={(event) => {
              handleChange(event);
            }}
          />
          <ImageUpload value={asset.Image} onChange={handleFileUploadChange} />
        </Stack>
        {asset.Type === "megafactory" && (
          <Stack direction={"column"} gap={2}>
            <Typography variant="h6">Add Suites</Typography>
            {asset.suites &&
              asset.suites.map((factory, index) => (
                <Stack
                  key={index}
                  gap={2}
                  border={1}
                  padding={2}
                  borderColor={"primary.main"}
                  borderRadius={1}
                >
                  {combinedAssets && (
                    <Stack direction={"row"} spacing={2}>
                      <Autocomplete
                        disablePortal
                        id="factorySelect"
                        options={getFactoryOptions()}
                        getOptionLabel={(option) => option.Title || ""}
                        isOptionEqualToValue={(option, value) =>
                          option.id === value?.id
                        }
                        sx={{ width: "100%" }}
                        size="small"
                        value={getSelectedFactory(factory.factoryId)}
                        onChange={(event, newValue) => {
                          handleFactoryChange(index, newValue);
                        }}
                        renderOption={(props, option) => (
                          <li {...props} key={option.id || option.Title}>
                            {option.Title || ""}
                          </li>
                        )}
                        renderInput={(params) => (
                          <TextField {...params} label="Title" />
                        )}
                      />
                      {index !== 0 && (
                        <IconButton
                          onClick={() => {
                            handleRemove(factory);
                          }}
                        >
                          <DeleteIcon></DeleteIcon>
                        </IconButton>
                      )}
                    </Stack>
                  )}
                  <TextField
                    id="title"
                    label="Tab Title Override"
                    fullWidth
                    value={factory.title || ""}
                    size="small"
                    name="title"
                    placeholder="Leave blank to use factory's original title"
                    onChange={(event) => handleTextChange(event, index)}
                  />
                  <TextField
                    id="color"
                    label="Color"
                    fullWidth
                    value={factory.color}
                    size="small"
                    onChange={(e) => handleColorChange(index, e.target.value)}
                  />
                  <TextField
                    id="text1"
                    label="Text Header"
                    fullWidth
                    value={factory.textHeader}
                    size="small"
                    name="textHeader"
                    onChange={(event) => handleTextChange(event, index)}
                  />
                  <TextField
                    id="text2"
                    label="Text"
                    fullWidth
                    value={factory.text}
                    name="text"
                    size="small"
                    onChange={(event) => handleTextChange(event, index)}
                  />
                </Stack>
              ))}
            {asset.suites && asset.suites.length < 4 && (
              <Button
                variant="outlined"
                endIcon={<AddCircleRoundedIcon />}
                onClick={() => {
                  handleAddMore();
                }}
              >
                Add More
              </Button>
            )}
          </Stack>
        )}

        {/* UNS Sidebar Configuration - megafactory only */}
        {asset.Type === "megafactory" && (
          <Stack direction="column" gap={2} sx={{ mt: 4 }}>
            <Divider />
            <Typography variant="h6">UNS Sidebar</Typography>
            <Typography variant="body2" color="textSecondary">
              Optionally display a live MQTT topic tree panel alongside the megafactory.
            </Typography>

            <FormControlLabel
              control={
                <Switch
                  checked={!!asset.unsConfig?.enabled}
                  onChange={(e) => {
                    const enabling = e.target.checked;
                    setAsset((prev) => {
                      const existing = prev.unsConfig || {};
                      const needsDefaultBranch = enabling && !(existing.topicBranches?.length > 0);
                      return {
                        ...prev,
                        unsConfig: {
                          ...existing,
                          enabled: enabling,
                          ...(needsDefaultBranch && { topicBranches: ["#"] }),
                        },
                      };
                    });
                  }}
                />
              }
              label="Enable UNS Sidebar"
            />

            {asset.unsConfig?.enabled && (() => {
              const suiteFactoryIds = (asset.suites || []).map((s) => s.factoryId).filter(Boolean);
              const suitesWithUns = suiteFactoryIds.filter((id) => {
                const factory = combinedAssets.find((a) => a.id === id);
                return factory?.unsConfig?.enabled;
              });
              return suitesWithUns.length > 0 ? (
                <Alert severity="info">
                  {suitesWithUns.length === 1 ? "One of your suites has" : "Some of your suites have"} a factory-level UNS sidebar configured. The megafactory UNS will take precedence when they are viewed here.
                </Alert>
              ) : null;
            })()}

            {asset.unsConfig?.enabled && (
              <Stack direction="column" gap={2}>
                {/* MQTT Configuration */}
                <Typography fontWeight="bold">MQTT Configuration</Typography>
                <TextField
                  label="Broker URL"
                  size="small"
                  fullWidth
                  value={asset.unsConfig?.mqttConfig?.broker || ""}
                  onChange={(e) =>
                    setAsset((prev) => ({
                      ...prev,
                      unsConfig: {
                        ...prev.unsConfig,
                        mqttConfig: { ...prev.unsConfig?.mqttConfig, broker: e.target.value },
                      },
                    }))
                  }
                  placeholder="wss://your-broker.com:8884/mqtt"
                  helperText="WebSocket URL of your MQTT broker"
                />
                <TextField
                  label="Username"
                  size="small"
                  fullWidth
                  value={asset.unsConfig?.mqttConfig?.username || ""}
                  onChange={(e) =>
                    setAsset((prev) => ({
                      ...prev,
                      unsConfig: {
                        ...prev.unsConfig,
                        mqttConfig: { ...prev.unsConfig?.mqttConfig, username: e.target.value },
                      },
                    }))
                  }
                />
                <TextField
                  label="Password"
                  type="password"
                  size="small"
                  fullWidth
                  value={asset.unsConfig?.mqttConfig?.password || ""}
                  onChange={(e) =>
                    setAsset((prev) => ({
                      ...prev,
                      unsConfig: {
                        ...prev.unsConfig,
                        mqttConfig: { ...prev.unsConfig?.mqttConfig, password: e.target.value },
                      },
                    }))
                  }
                />
                <TextField
                  label="Topic Prefix"
                  size="small"
                  fullWidth
                  value={asset.unsConfig?.mqttConfig?.topicPrefix || ""}
                  onChange={(e) =>
                    setAsset((prev) => ({
                      ...prev,
                      unsConfig: {
                        ...prev.unsConfig,
                        mqttConfig: { ...prev.unsConfig?.mqttConfig, topicPrefix: e.target.value },
                      },
                    }))
                  }
                  placeholder="MyEnterprise"
                  helperText="Common prefix for all topic paths"
                />

                <Divider sx={{ my: 1 }} />

                {/* Topic Branches */}
                <Typography fontWeight="bold">Topic Branches</Typography>
                <Typography variant="body2" color="textSecondary">
                  MQTT topic patterns to subscribe to. Use # for wildcards. These define the "Overall" view.
                </Typography>
                {(asset.unsConfig?.topicBranches || []).map((branch, index) => (
                  <Stack key={index} direction="row" gap={1} alignItems="center">
                    <TextField
                      size="small"
                      fullWidth
                      value={branch}
                      onChange={(e) => {
                        const newBranches = [...(asset.unsConfig?.topicBranches || [])];
                        newBranches[index] = e.target.value;
                        setAsset((prev) => ({
                          ...prev,
                          unsConfig: { ...prev.unsConfig, topicBranches: newBranches },
                        }));
                      }}
                      placeholder="MyEnterprise/Site1/#"
                    />
                    <IconButton
                      size="small"
                      onClick={() => {
                        const newBranches = (asset.unsConfig?.topicBranches || []).filter(
                          (_, i) => i !== index
                        );
                        setAsset((prev) => ({
                          ...prev,
                          unsConfig: { ...prev.unsConfig, topicBranches: newBranches },
                        }));
                      }}
                    >
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  </Stack>
                ))}
                <Button
                  size="small"
                  variant="outlined"
                  startIcon={<AddIcon />}
                  onClick={() => {
                    const newBranches = [...(asset.unsConfig?.topicBranches || []), ""];
                    setAsset((prev) => ({
                      ...prev,
                      unsConfig: { ...prev.unsConfig, topicBranches: newBranches },
                    }));
                  }}
                >
                  Add Topic Branch
                </Button>

                <Divider sx={{ my: 1 }} />

                {/* Site Filters */}
                <Typography fontWeight="bold">Site Filters (optional)</Typography>
                <Typography variant="body2" color="textSecondary">
                  Add filters to let users narrow the tree to specific branches. When empty, the sidebar shows all topic branches with no dropdown.
                </Typography>
                {(asset.unsConfig?.siteFilters || []).map((filter, index) => (
                  <Box key={index} sx={{ border: "1px solid #ccc", borderRadius: 1, p: 1.5 }}>
                    <Stack direction="column" gap={1}>
                      <Stack direction="row" gap={1} alignItems="center">
                        <TextField
                          label="Label"
                          size="small"
                          fullWidth
                          value={filter.label || ""}
                          onChange={(e) => {
                            const newFilters = [...(asset.unsConfig?.siteFilters || [])];
                            newFilters[index] = {
                              ...newFilters[index],
                              label: e.target.value,
                              value: e.target.value.toLowerCase().replace(/\s+/g, "-"),
                            };
                            setAsset((prev) => ({
                              ...prev,
                              unsConfig: { ...prev.unsConfig, siteFilters: newFilters },
                            }));
                          }}
                          placeholder="Site 1"
                        />
                        <IconButton
                          size="small"
                          onClick={() => {
                            const newFilters = (asset.unsConfig?.siteFilters || []).filter(
                              (_, i) => i !== index
                            );
                            setAsset((prev) => ({
                              ...prev,
                              unsConfig: { ...prev.unsConfig, siteFilters: newFilters },
                            }));
                          }}
                        >
                          <DeleteIcon fontSize="small" />
                        </IconButton>
                      </Stack>
                      <TextField
                        label="Topic Pattern"
                        size="small"
                        fullWidth
                        value={filter.topicPattern || ""}
                        onChange={(e) => {
                          const newFilters = [...(asset.unsConfig?.siteFilters || [])];
                          newFilters[index] = { ...newFilters[index], topicPattern: e.target.value };
                          setAsset((prev) => ({
                            ...prev,
                            unsConfig: { ...prev.unsConfig, siteFilters: newFilters },
                          }));
                        }}
                        placeholder="MyEnterprise/Site1/#"
                        helperText="MQTT topic pattern with wildcard"
                      />
                    </Stack>
                  </Box>
                ))}
                <Button
                  size="small"
                  variant="outlined"
                  startIcon={<AddIcon />}
                  onClick={() => {
                    const newFilters = [
                      ...(asset.unsConfig?.siteFilters || []),
                      { label: "", value: "", topicPattern: "" },
                    ];
                    setAsset((prev) => ({
                      ...prev,
                      unsConfig: { ...prev.unsConfig, siteFilters: newFilters },
                    }));
                  }}
                >
                  Add Site Filter
                </Button>

                {/* Default Filter */}
                {(asset.unsConfig?.siteFilters || []).length > 0 && (
                  <>
                    <Divider sx={{ my: 1 }} />
                    <FormControl fullWidth size="small">
                      <InputLabel>Default Filter</InputLabel>
                      <Select
                        label="Default Filter"
                        value={asset.unsConfig?.defaultFilter || "overall"}
                        onChange={(e) =>
                          setAsset((prev) => ({
                            ...prev,
                            unsConfig: { ...prev.unsConfig, defaultFilter: e.target.value },
                          }))
                        }
                      >
                        <MenuItem value="overall">Overall (all branches)</MenuItem>
                        {(asset.unsConfig?.siteFilters || []).map((f) =>
                          f.value ? (
                            <MenuItem key={f.value} value={f.value}>
                              {f.label || f.value}
                            </MenuItem>
                          ) : null
                        )}
                      </Select>
                    </FormControl>
                  </>
                )}
              </Stack>
            )}
          </Stack>
        )}
      </Grid>
    </Grid>
  );
}
